import { render, staticRenderFns } from "./Page2Chart1.vue?vue&type=template&id=3f1db5d1&scoped=true&"
import script from "./Page2Chart1.vue?vue&type=script&lang=ts&"
export * from "./Page2Chart1.vue?vue&type=script&lang=ts&"
import style0 from "./Page2Chart1.vue?vue&type=style&index=0&id=3f1db5d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1db5d1",
  null
  
)

export default component.exports